export const clampScroll = (offset: number, maximum: number) =>
  Math.max(0, Math.min(offset, Math.max(0, maximum)));
